import React, { useEffect, useState } from "react";
import { Tag, Plus, Trash2, Pencil, Check, X, ChevronDown, Power } from "lucide-react";
import { toast } from "sonner";
import client, { errText } from "@/lib/api";

export default function AdminCategories() {
  const [cats, setCats] = useState([]);
  const [newName, setNewName] = useState("");
  const [editId, setEditId] = useState(null);
  const [editName, setEditName] = useState("");
  const [openSub, setOpenSub] = useState(null);
  const [subName, setSubName] = useState("");

  const load = () => client.get("/meta").then((r) => setCats((r.data.categories || []).slice().sort((a, b) => (a.order || 0) - (b.order || 0)))).catch(() => {});
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!newName.trim()) return;
    try { await client.post("/admin/categories", { name: newName.trim() }); setNewName(""); toast.success("تمت الإضافة"); load(); }
    catch (e) { toast.error(errText(e)); }
  };
  const saveEdit = async (cid) => {
    try { await client.put(`/admin/categories/${cid}`, { name: editName.trim() }); setEditId(null); toast.success("تم الحفظ"); load(); }
    catch (e) { toast.error(errText(e)); }
  };
  const toggleActive = async (c) => {
    try { await client.put(`/admin/categories/${c.id}`, { active: c.active === false }); load(); }
    catch (e) { toast.error(errText(e)); }
  };
  const del = async (cid) => {
    if (!window.confirm("حذف هذا التصنيف؟ (لا يمكن حذف تصنيف مرتبط بمنتجات)")) return;
    try { await client.delete(`/admin/categories/${cid}`); toast.success("تم الحذف"); load(); }
    catch (e) { toast.error(errText(e)); }
  };
  const move = async (idx, dir) => {
    const arr = cats.slice();
    const j = idx + dir;
    if (j < 0 || j >= arr.length) return;
    [arr[idx], arr[j]] = [arr[j], arr[idx]];
    setCats(arr);
    try { await client.put("/admin/categories-reorder", { ids: arr.map((c) => c.id) }); }
    catch (e) { toast.error(errText(e)); load(); }
  };
  const addSub = async (cid) => {
    if (!subName.trim()) return;
    try { await client.post(`/admin/categories/${cid}/subs`, { name: subName.trim() }); setSubName(""); toast.success("تم"); load(); }
    catch (e) { toast.error(errText(e)); }
  };
  const delSub = async (cid, sid) => {
    try { await client.delete(`/admin/categories/${cid}/subs/${sid}`); load(); }
    catch (e) { toast.error(errText(e)); }
  };

  return (
    <div dir="rtl">
      <h2 className="font-head text-[16px] font-bold px-4 pt-5 pb-2 flex items-center gap-1.5"><Tag size={17} style={{ color: "var(--k-gold-deep)" }} /> الأقسام والتصنيفات ({cats.length})</h2>
      <div className="px-4 pb-6">
        <div className="flex gap-2 mb-4">
          <input data-testid="cat-new-input" value={newName} onChange={(e) => setNewName(e.target.value)} placeholder="اسم قسم جديد" className="flex-1 rounded-xl px-3 py-2.5 text-[13px]" style={{ background: "var(--k-paper)", border: "1px solid var(--k-line)" }} />
          <button data-testid="cat-add-btn" onClick={add} className="k-tap px-4 py-2.5 rounded-xl font-bold text-[13px] text-white flex items-center gap-1" style={{ background: "var(--k-ink)" }}><Plus size={15} /> إضافة</button>
        </div>
        <div className="space-y-2">
          {cats.map((c, idx) => (
            <div key={c.id} data-testid={`cat-row-${c.id}`} className="rounded-2xl p-3" style={{ background: "var(--k-surface)", border: "1px solid var(--k-line)", opacity: c.active === false ? 0.6 : 1 }}>
              <div className="flex items-center gap-2">
                <div className="flex flex-col">
                  <button onClick={() => move(idx, -1)} className="k-tap text-[10px] leading-none border-0 bg-transparent" style={{ color: "var(--k-ink-soft)" }}>▲</button>
                  <button onClick={() => move(idx, 1)} className="k-tap text-[10px] leading-none border-0 bg-transparent" style={{ color: "var(--k-ink-soft)" }}>▼</button>
                </div>
                {editId === c.id ? (
                  <>
                    <input data-testid={`cat-edit-input-${c.id}`} value={editName} onChange={(e) => setEditName(e.target.value)} className="flex-1 rounded-lg px-2 py-1.5 text-[13px]" style={{ background: "var(--k-paper)", border: "1px solid var(--k-line)" }} />
                    <button data-testid={`cat-save-${c.id}`} onClick={() => saveEdit(c.id)} className="k-tap p-1.5 rounded-lg text-white" style={{ background: "var(--k-emerald)" }}><Check size={14} /></button>
                    <button onClick={() => setEditId(null)} className="k-tap p-1.5 rounded-lg" style={{ background: "var(--k-paper)", border: "1px solid var(--k-line)" }}><X size={14} /></button>
                  </>
                ) : (
                  <>
                    <span className="flex-1 font-bold text-[14px]">{c.name} {c.active === false && <span className="text-[10px]" style={{ color: "var(--k-ruby)" }}>(معطّل)</span>}</span>
                    <button data-testid={`cat-sub-toggle-${c.id}`} onClick={() => setOpenSub(openSub === c.id ? null : c.id)} className="k-tap p-1.5 rounded-lg text-[11px] flex items-center gap-1" style={{ background: "var(--k-paper)", border: "1px solid var(--k-line)" }}>فرعية <ChevronDown size={12} /></button>
                    <button data-testid={`cat-toggle-${c.id}`} onClick={() => toggleActive(c)} className="k-tap p-1.5 rounded-lg" style={{ background: "var(--k-paper)", border: "1px solid var(--k-line)", color: c.active === false ? "var(--k-ink-soft)" : "var(--k-emerald)" }}><Power size={14} /></button>
                    <button data-testid={`cat-edit-${c.id}`} onClick={() => { setEditId(c.id); setEditName(c.name); }} className="k-tap p-1.5 rounded-lg" style={{ background: "var(--k-paper)", border: "1px solid var(--k-line)" }}><Pencil size={14} /></button>
                    <button data-testid={`cat-del-${c.id}`} onClick={() => del(c.id)} className="k-tap p-1.5 rounded-lg" style={{ background: "var(--k-paper)", border: "1px solid var(--k-line)", color: "var(--k-ruby)" }}><Trash2 size={14} /></button>
                  </>
                )}
              </div>
              {openSub === c.id && (
                <div className="mt-2 pt-2" style={{ borderTop: "1px solid var(--k-line)" }}>
                  <div className="flex flex-wrap gap-1.5 mb-2">
                    {(c.subs || []).length === 0 && <span className="text-[11px]" style={{ color: "var(--k-ink-soft)" }}>لا توجد تصنيفات فرعية</span>}
                    {(c.subs || []).map((s) => (
                      <span key={s.id} className="text-[11px] font-semibold px-2 py-1 rounded-full flex items-center gap-1" style={{ background: "var(--k-paper)", border: "1px solid var(--k-line)" }}>
                        {s.name}
                        <button data-testid={`subcat-del-${s.id}`} onClick={() => delSub(c.id, s.id)} className="k-tap border-0 bg-transparent" style={{ color: "var(--k-ruby)" }}><Trash2 size={11} /></button>
                      </span>
                    ))}
                  </div>
                  <div className="flex gap-2">
                    <input data-testid={`subcat-input-${c.id}`} value={openSub === c.id ? subName : ""} onChange={(e) => setSubName(e.target.value)} placeholder="اسم تصنيف فرعي" className="flex-1 rounded-lg px-2 py-1.5 text-[12px]" style={{ background: "var(--k-paper)", border: "1px solid var(--k-line)" }} />
                    <button data-testid={`subcat-add-${c.id}`} onClick={() => addSub(c.id)} className="k-tap px-3 py-1.5 rounded-lg text-[12px] font-bold text-white" style={{ background: "var(--k-ink)" }}>إضافة</button>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
